import {
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@f2e/ui/components/base"

export interface DestinationFormFieldsProps {
  name: string
  destinationType: string
  endpoint: string
  typeDisabled?: boolean
  nameLabel: string
  typeLabel: string
  endpointLabel: string
  endpointPlaceholder: string
  slackIncomingLabel: string
  slackWorkflowLabel: string
  emailLabel: string
  onNameChange: (value: string) => void
  onDestinationTypeChange: (value: string) => void
  onEndpointChange: (value: string) => void
}

export const DestinationFormFields = ({
  name,
  destinationType,
  endpoint,
  typeDisabled = false,
  nameLabel,
  typeLabel,
  endpointLabel,
  endpointPlaceholder,
  slackIncomingLabel,
  slackWorkflowLabel,
  emailLabel,
  onNameChange,
  onDestinationTypeChange,
  onEndpointChange,
}: DestinationFormFieldsProps) => (
  <div className="space-y-4">
    <div className="space-y-2">
      <Label htmlFor="notification-destination-name">{nameLabel}</Label>
      <Input
        id="notification-destination-name"
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
      />
    </div>
    <div className="space-y-2">
      <Label htmlFor="notification-destination-type">{typeLabel}</Label>
      <Select
        value={destinationType}
        disabled={typeDisabled}
        onValueChange={onDestinationTypeChange}
      >
        <SelectTrigger id="notification-destination-type">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="slack_webhook">{slackIncomingLabel}</SelectItem>
          <SelectItem value="slack_workflow_webhook">
            {slackWorkflowLabel}
          </SelectItem>
          <SelectItem value="email">{emailLabel}</SelectItem>
        </SelectContent>
      </Select>
    </div>
    <div className="space-y-2">
      <Label htmlFor="notification-destination-endpoint">{endpointLabel}</Label>
      <Input
        id="notification-destination-endpoint"
        value={endpoint}
        placeholder={endpointPlaceholder}
        onChange={(event) => onEndpointChange(event.target.value)}
      />
    </div>
  </div>
)
